import bank from "./styles/img/assets/bank.svg";
import crypto from "./styles/img/assets/crypto.svg";
import investment from "./styles/img/assets/investment.svg";
import life_insurance from "./styles/img/assets/life_insurance.svg";
import nft from "./styles/img/assets/nft.svg";
import other from "./styles/img/assets/other.svg";
import password_manager from "./styles/img/assets/password_manager.svg";
import password from "./styles/img/assets/password.svg";
import real_estate from "./styles/img/assets/real_estate.svg";
import retirement from "./styles/img/assets/retirement.svg";
import shares from "./styles/img/assets/shares.svg";
import vault from "./styles/img/assets/vault.svg";
import web3 from "./styles/img/assets/web3.svg";
import will from "./styles/img/assets/will.svg";
import online_storage from "./styles/img/assets/online_storage.svg";
/*
  The later types, supplied as 48px PNGs rather than SVGs. Renamed on the way in
  to the lowercase-underscore convention the rest of this folder uses — the
  originals arrived title-cased and spaced, and "Recivable Loan" was both
  misspelled and the wrong way round for the type it belongs to.
*/
import business_ownership from "./styles/img/assets/business_ownership.png";
import cash from "./styles/img/assets/cash.png";
import company from "./styles/img/assets/company.png";
import custom from "./styles/img/assets/custom.png";
import employee_benefits from "./styles/img/assets/employee_benefits.png";
import intellectual_property from "./styles/img/assets/intellectual_property.png";
import loans_receivable from "./styles/img/assets/loans_receivable.png";
import vehicle from "./styles/img/assets/vehicle.png";

/*
  Icons are matched on the stored `asset_type` string, so this list must move
  with the option values — not with the labels, which are copy and change
  independently in the language files.
*/
export const selectLogo = (asset_type) => {
  switch (String(asset_type || "").toLowerCase()) {
    case "bank account":
      return bank;
    case "crypto wallet":
      return crypto;
    case "life insurance":
      return life_insurance;
    case "investment account":
      return investment;
    case "investment acount":
      return investment;
    case "company shares":
      return shares;
    case "nft":
      return nft;
    case "password manager":
      return password_manager;
    case "password":
      return password;
    case "real estate":
      return real_estate;
    case "retirement plan":
      return retirement;
    case "web 3 assets":
      return web3;
    case "physical vault":
      return vault;
    case "your will":
      return will;
    // The Edit modal used to save this type with an underscore, so both forms
    // exist in older data and both must resolve to the same icon.
    case "online storage":
    case "online_storage":
      return online_storage;

    case "company":
      return company;
    case "vehicle":
      return vehicle;
    case "business ownership":
      return business_ownership;
    case "loans receivable":
      return loans_receivable;
    case "cash":
      return cash;
    case "intellectual property":
      return intellectual_property;
    case "employee benefits":
      return employee_benefits;

    /*
      "Other" is a built-in type in its own right, not an unrecognised value —
      it has to be listed, or the default below would take it for one of the
      user's own and give it the custom icon.
    */
    case "other":
      return other;

    /*
      TODO(design): still no artwork for this one, so it keeps the generic icon.
      Add the import at the top and return it here; nothing else changes.
    */
    case "precious objects":
      return other;

    default:
      /*
        Not a built-in type. Either one of the user's own custom types — which
        are stored as their label, so there is nothing to match on — or a value
        from before a rename. The custom icon says "this is yours" rather than
        "this is unrecognised", which is right for the first and harmless for
        the second.

        An empty type is neither, and keeps the generic icon.
      */
      return String(asset_type || "").trim() ? custom : other;
  }
};
